// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"1a996bcc","769":"fdd118b6"}[chunkId] + ".chunk.js";
};